import request from "@/util/http"; //获取教职工花名册列表

export function getStaffPage(params) {
  return request({
    url: "/hq/facultyAndStaff/page",
    method: "get",
    params: params
  });
} //工资查询

export function getMangeList(params) {
  return request({
    url: "/hq/pay/page",
    method: "get",
    params: params
  });
} //年度考核评选结果查询列表

export function yearCheckList(params) {
  return request({
    url: "/hq/yearCheck/page",
    method: "get",
    params: params
  });
} //岗位聘用查询

export function postEmploy(params) {
  return request({
    url: "/hq/postEmploy/page",
    method: "get",
    params: params
  });
} // 年度考核评选Excel下载模板

export var downloadTemp = function downloadTemp() {
  return "/hq/yearCheck/downloadTemp";
}; // 岗位聘用查询Excel下载模板

export var jobDowlod = function jobDowlod() {
  return "/hq/postEmploy/downloadTemp";
}; // 岗位聘级别获取

export var parentList = function parentList() {
  return request({
    url: "/hq/postInfo/parentList",
    method: "get"
  });
}; // 岗位聘等级

export var childList = function childList(id) {
  return request({
    url: "/hq/postInfo/childList/".concat(id),
    method: "get"
  });
}; //  获取学期信息

export var semesterList = function semesterList() {
  return request({
    url: "/hq/semester/list",
    method: "get"
  });
}; //  根据年级id查班级

export var classList = function classList(params) {
  return request({
    url: "/hq/administrationClass/getClassList",
    method: "get",
    params: params
  });
}; //年级list

export var gradeList = function gradeList(params) {
  return request({
    url: "/hq/administrationClass/getGradeNameList",
    method: "get",
    params: params
  });
}; //学生成绩统计

export var finalGrade = function finalGrade(params) {
  return request({
    url: "/hq/finalGrade/page",
    method: "get",
    params: params
  });
}; // Excel导出

export var excelExport = function excelExport(params) {
  var str = "";

  for (var key in params) {
    str += "&".concat(key, "=").concat(params[key]);
  }

  return "/hq/finalGrade/exportGradeUser?".concat(str);
}; //专业科下拉框

export var getOrgNameList = function getOrgNameList(params) {
  return request({
    url: "/hq/administrationClass/getOrgNameList",
    method: "get",
    params: params
  });
}; //专业下拉框

export var getSpecialtyNameList = function getSpecialtyNameList(id) {
  return request({
    url: "/hq/administrationClass/getSpecialtyNameList/".concat(id),
    method: "get"
  });
};